export const formatTipAmount = (amount) => Math.round(amount * 100) / 100;

export const TIP_MIN_AMOUNT = 0.01;
export const TIP_MAX_AMOUNT = 10000;

export const getTipValidationError = (amount) => {
  if (!Number.isFinite(amount)) {
    return null;
  }

  if (amount < TIP_MIN_AMOUNT) {
    return `Minimum tip amount is $${TIP_MIN_AMOUNT.toFixed(2)}`;
  }

  if (amount > TIP_MAX_AMOUNT) {
    return `Maximum tip amount is $${TIP_MAX_AMOUNT.toFixed(2)}`;
  }

  return null;
};

export const normalizeCustomTipAmount = (value) => {
  if (!value) {
    return 0;
  }

  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return 0;
  }

  return formatTipAmount(parsed);
};
